import { render, staticRenderFns } from "./VacationListTable.vue?vue&type=template&id=107ca2c6"
import script from "./VacationListTable.vue?vue&type=script&lang=js"
export * from "./VacationListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports